/* SI Streetwear — Ocean Blue :: theme behaviours */
(function () {
  'use strict';

  /* ---------- Mobile navigation ---------- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var drawer = document.querySelector('[data-mobile-nav]');
    if (!toggle || !drawer) return;

    toggle.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        drawer.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  }

  /* ---------- Sticky header shadow ---------- */
  function initStickyHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var update = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var items = document.querySelectorAll('.reveal');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });

    items.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Quantity steppers ---------- */
  function initQuantity() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty]');
      if (!btn) return;

      var wrapper = btn.closest('.quantity');
      var input = wrapper && wrapper.querySelector('input');
      if (!input) return;

      var min = parseInt(input.getAttribute('min') || '1', 10);
      var value = parseInt(input.value || '1', 10);
      value = btn.getAttribute('data-qty') === 'up' ? value + 1 : value - 1;
      input.value = Math.max(min, value);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;

    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        var alt = thumb.getAttribute('data-alt') || '';
        if (src) {
          main.setAttribute('src', src);
          main.setAttribute('alt', alt);
          main.removeAttribute('srcset');
        }
        thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---------- Variant selection ---------- */
  function initVariants() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    var dataEl = document.querySelector('[data-variant-json]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }

    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-product-price]');
    var submit = form.querySelector('[data-add-button]');
    var mainImage = document.querySelector('[data-gallery-main]');
    var moneyFormat = dataEl.getAttribute('data-money-format') || '${{amount}}';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var parts = amount.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, parts.join('.'));
    }

    function selectedOptions() {
      return Array.prototype.map.call(
        form.querySelectorAll('[data-option-index]'),
        function (group) {
          var active = group.querySelector('.option__value.is-selected');
          return active ? active.getAttribute('data-value') : null;
        }
      );
    }

    function update() {
      var chosen = selectedOptions();
      var match = variants.find(function (v) {
        return chosen.every(function (opt, i) {
          return opt === null || v.options[i] === opt;
        });
      });

      if (!match) return;

      if (idInput) idInput.value = match.id;

      if (priceEl) {
        var html = '<span class="price__current">' + formatMoney(match.price) + '</span>';
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += '<span class="price__compare">' + formatMoney(match.compare_at_price) + '</span>';
        }
        priceEl.innerHTML = html;
        priceEl.classList.toggle(
          'price--on-sale',
          Boolean(match.compare_at_price && match.compare_at_price > match.price)
        );
      }

      if (match.featured_image && mainImage) {
        mainImage.setAttribute('src', match.featured_image);
        mainImage.removeAttribute('srcset');
      }

      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available ? 'Add to cart' : 'Sold out';
      }

      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    form.addEventListener('click', function (e) {
      var value = e.target.closest('.option__value');
      if (!value) return;
      e.preventDefault();

      var group = value.closest('[data-option-index]');
      group.querySelectorAll('.option__value').forEach(function (el) {
        el.classList.remove('is-selected');
        el.setAttribute('aria-pressed', 'false');
      });
      value.classList.add('is-selected');
      value.setAttribute('aria-pressed', 'true');
      update();
    });

    update();
  }

  /* ---------- Cart drawer ---------- */
  var cartDrawer = {
    root: null,
    moneyFormat: '${{amount}}',
    threshold: 0,

    formatMoney: function (cents) {
      var amount = (cents / 100).toFixed(2);
      var parts = amount.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return this.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, parts.join('.'));
    },

    open: function () {
      if (!this.root) return;
      this.root.classList.add('is-open');
      this.root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open');
    },

    close: function () {
      if (!this.root) return;
      this.root.classList.remove('is-open');
      this.root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
    },

    refresh: function () {
      var self = this;
      return fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) { self.render(cart); return cart; });
    },

    render: function (cart) {
      var itemsEl = this.root.querySelector('[data-drawer-items]');
      var emptyEl = this.root.querySelector('[data-drawer-empty]');
      var footEl = this.root.querySelector('[data-drawer-foot]');
      var countEl = this.root.querySelector('[data-drawer-count]');
      var subtotalEl = this.root.querySelector('[data-drawer-subtotal]');
      var self = this;

      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });

      if (countEl) countEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
      if (subtotalEl) subtotalEl.textContent = this.formatMoney(cart.items_subtotal_price);

      var progressEl = this.root.querySelector('[data-drawer-progress]');
      if (progressEl && this.threshold > 0 && cart.item_count > 0) {
        progressEl.hidden = false;
        var label = progressEl.querySelector('[data-drawer-progress-label]');
        var fill = progressEl.querySelector('[data-drawer-progress-fill]');
        var pct = Math.min(100, Math.round((cart.total_price / this.threshold) * 100));
        if (fill) fill.style.width = pct + '%';
        if (label) {
          label.innerHTML = cart.total_price >= this.threshold
            ? '<strong>You’ve unlocked free shipping!</strong>'
            : 'You’re <strong>' + this.formatMoney(this.threshold - cart.total_price) + '</strong> away from free shipping';
        }
      } else if (progressEl) {
        progressEl.hidden = true;
      }

      if (cart.item_count === 0) {
        itemsEl.innerHTML = '';
        if (emptyEl) emptyEl.hidden = false;
        if (footEl) footEl.style.display = 'none';
        return;
      }

      if (emptyEl) emptyEl.hidden = true;
      if (footEl) footEl.style.display = '';

      itemsEl.innerHTML = cart.items.map(function (item, i) {
        var variantTitle = item.variant_title ? '<div class="cart-item__variant">' + item.variant_title + '</div>' : '';
        var imageUrl = item.image
          ? item.image + (item.image.indexOf('?') === -1 ? '?' : '&') + 'width=200'
          : null;
        var image = imageUrl
          ? '<img src="' + imageUrl + '" alt="" width="80" height="80" loading="lazy">'
          : '';
        return (
          '<div class="drawer-item" data-line="' + (i + 1) + '">' +
            '<a class="drawer-item__media" href="' + item.url + '">' + image + '</a>' +
            '<div class="drawer-item__info">' +
              '<a class="cart-item__title" href="' + item.url + '">' + item.product_title + '</a>' +
              variantTitle +
              '<div class="drawer-item__row">' +
                '<div class="quantity quantity--sm">' +
                  '<button type="button" data-drawer-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
                  '<input type="number" value="' + item.quantity + '" min="0" data-drawer-qty-input aria-label="Quantity">' +
                  '<button type="button" data-drawer-qty="1" aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<strong>' + cartDrawer.formatMoney(item.final_line_price) + '</strong>' +
              '</div>' +
            '</div>' +
            '<button type="button" class="drawer-item__remove" data-drawer-remove aria-label="Remove ' + item.product_title.replace(/"/g, '&quot;') + '">' +
              '&times;' +
            '</button>' +
          '</div>'
        );
      }).join('');
    },

    changeLine: function (line, quantity) {
      var self = this;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) { self.render(cart); });
    },

    add: function (variantId, quantity) {
      var self = this;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
      }).then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return self.refresh().then(function () { self.open(); });
      });
    }
  };

  function initCartDrawer() {
    var root = document.querySelector('[data-cart-drawer]');
    if (!root) return;
    if (root.hasAttribute('data-drawer-initialized')) return;
    root.setAttribute('data-drawer-initialized', '');

    cartDrawer.root = root;
    cartDrawer.moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    cartDrawer.threshold = parseInt(root.getAttribute('data-free-shipping-threshold') || '0', 10);

    cartDrawer.refresh();

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-cart-toggle]');
      if (toggle) {
        e.preventDefault();
        cartDrawer.refresh().then(function () { cartDrawer.open(); });
        return;
      }

      if (e.target.closest('[data-drawer-close]')) {
        var closeLink = e.target.closest('a[data-drawer-close]');
        cartDrawer.close();
        if (!closeLink) e.preventDefault();
        return;
      }

      var removeBtn = e.target.closest('[data-drawer-remove]');
      if (removeBtn) {
        var line = removeBtn.closest('[data-line]').getAttribute('data-line');
        cartDrawer.changeLine(parseInt(line, 10), 0);
        return;
      }

      var qtyBtn = e.target.closest('[data-drawer-qty]');
      if (qtyBtn) {
        var row = qtyBtn.closest('[data-line]');
        var input = row.querySelector('[data-drawer-qty-input]');
        var next = Math.max(0, parseInt(input.value || '0', 10) + parseInt(qtyBtn.getAttribute('data-drawer-qty'), 10));
        cartDrawer.changeLine(parseInt(row.getAttribute('data-line'), 10), next);
      }
    });

    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-drawer-qty-input]')) return;
      var row = e.target.closest('[data-line]');
      cartDrawer.changeLine(
        parseInt(row.getAttribute('data-line'), 10),
        Math.max(0, parseInt(e.target.value || '0', 10))
      );
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) cartDrawer.close();
    });

    // Intercept the product form so adds open the drawer instead of navigating
    var productForm = document.querySelector('[data-product-form]');
    if (productForm) {
      productForm.addEventListener('submit', function (e) {
        var submitter = e.submitter;
        if (submitter && submitter.name === 'checkout') return;
        e.preventDefault();

        var idInput = productForm.querySelector('[data-variant-id]');
        var qtyInput = productForm.querySelector('input[name="quantity"]');
        var addBtn = productForm.querySelector('[data-add-button]');
        if (!idInput) return;

        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = 'Adding…';
        }

        cartDrawer
          .add(idInput.value, parseInt((qtyInput && qtyInput.value) || '1', 10))
          .catch(function (err) {
            alert((err && err.description) || 'Could not add to cart.');
          })
          .finally(function () {
            if (addBtn) {
              addBtn.disabled = false;
              addBtn.textContent = 'Add to cart';
            }
          });
      });
    }

    // Quick-add buttons on product cards
    document.addEventListener('click', function (e) {
      var quickBtn = e.target.closest('[data-quick-add]');
      if (!quickBtn) return;
      e.preventDefault();

      quickBtn.classList.add('is-loading');
      cartDrawer
        .add(quickBtn.getAttribute('data-quick-add'), 1)
        .catch(function (err) {
          alert((err && err.description) || 'Could not add to cart.');
        })
        .finally(function () {
          quickBtn.classList.remove('is-loading');
        });
    });
  }

  /* ---------- Hero slideshow ---------- */
  function initHeroSlideshow() {
    document.querySelectorAll('[data-hero]').forEach(function (hero) {
      var slides = hero.querySelectorAll('[data-hero-slide]');
      if (slides.length < 2) return;

      var dots = hero.querySelectorAll('[data-hero-dot]');
      var interval = parseInt(hero.getAttribute('data-hero-interval') || '6000', 10);
      var current = 0;
      var timer = null;

      function show(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === current);
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === current);
        });
      }

      function play() {
        stop();
        timer = setInterval(function () { show(current + 1); }, interval);
      }

      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          show(i);
          play();
        });
      });

      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', play);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      play();
    });
  }

  /* ---------- Product carousels ---------- */
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (track) {
      var section = track.closest('.section') || document;
      var nav = section.querySelector('[data-carousel-nav]');
      if (!nav) return;

      var prev = nav.querySelector('[data-carousel-prev]');
      var next = nav.querySelector('[data-carousel-next]');

      function step() {
        var first = track.firstElementChild;
        if (!first) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
        var perView = Math.max(1, Math.round(track.clientWidth / (first.offsetWidth + gap)));
        return (first.offsetWidth + gap) * perView;
      }

      function sync() {
        var max = track.scrollWidth - track.clientWidth - 1;
        if (prev) prev.disabled = track.scrollLeft <= 0;
        if (next) next.disabled = track.scrollLeft >= max;
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ---------- Wishlist (local, no app required) ---------- */
  function initWishlist() {
    var KEY = 'si-wishlist';

    function read() {
      try {
        return JSON.parse(localStorage.getItem(KEY)) || [];
      } catch (err) {
        return [];
      }
    }

    function write(ids) {
      try {
        localStorage.setItem(KEY, JSON.stringify(ids));
      } catch (err) { /* storage unavailable — badge just won't persist */ }
    }

    function paintCount() {
      var n = read().length;
      document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
        el.textContent = n;
        el.style.display = n > 0 ? '' : 'none';
      });
    }

    var saved = read();
    document.querySelectorAll('[data-wishlist]').forEach(function (btn) {
      var id = btn.getAttribute('data-wishlist');
      if (saved.indexOf(id) !== -1) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
      }

      btn.addEventListener('click', function () {
        var ids = read();
        var at = ids.indexOf(id);
        if (at === -1) {
          ids.push(id);
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
        } else {
          ids.splice(at, 1);
          btn.classList.remove('is-active');
          btn.setAttribute('aria-pressed', 'false');
        }
        write(ids);
        paintCount();
      });
    });

    paintCount();
  }

  function init() {
    initMobileNav();
    initStickyHeader();
    initReveal();
    initQuantity();
    initGallery();
    initVariants();
    initHeroSlideshow();
    initCartDrawer();
    initCarousels();
    initWishlist();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when the theme editor swaps a section
  document.addEventListener('shopify:section:load', init);
})();
